import script from "./Page4.vue?vue&type=script&setup=true&lang=js"
export * from "./Page4.vue?vue&type=script&setup=true&lang=js"

import "./Page4.vue?vue&type=style&index=0&id=552bc143&lang=less"

const __exports__ = script;

export default __exports__